module.exports = __webpack_public_path__ + "static/img/xueshu2.429b3846.webp";